'use client';

import { c as _c } from "react/compiler-runtime";
import { getDataWrapperSchema } from '@repo/schema/data-wrapper';
import { GetPackagingTypeSchema } from '@repo/schema/load';
import { useDbSessionQueryCollection } from '@repo/tanstack/db';
import { useBaseUpFetch } from '@repo/upfetch';
const PackagingTypesSchema = getDataWrapperSchema(GetPackagingTypeSchema.array());
export const usePackagingTypes = () => {
  const $ = _c(5);
  const upfetch = useBaseUpFetch();
  let t0;
  if ($[0] !== upfetch) {
    t0 = () => upfetch("/public/packaging-types", {
      schema: PackagingTypesSchema
    });
    $[0] = upfetch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["/public/packaging-types"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = {
      getKey: _temp,
      id: "packaging-types",
      queryFn: t0,
      queryKey: t1,
      schemaVersion: 1,
      staleTime: 300000
    };
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useDbSessionQueryCollection(t2);
};
function _temp(row) {
  return row.id;
}